import React from "react";
var __jsx = React.createElement;
import stl from "./SingleTitleStep.module.css";
var SingleTitleStep = function SingleTitleStep(_ref) {
  var _ref$isDone = _ref.isDone,
    isDone = _ref$isDone === void 0 ? false : _ref$isDone,
    title = _ref.title,
    _ref$currentStep = _ref.currentStep,
    currentStep = _ref$currentStep === void 0 ? false : _ref$currentStep;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.SingleTitleStepContainer, currentStep ? stl.currentTitle : undefined, isDone ? stl.doneTitle : undefined].join(" ")
  }, title);
};
export default SingleTitleStep;